import { Clock, Bug } from 'lucide-react'
import './RunSummary.css'

interface RunSummaryProps {
  queuedAt?: string | null
  startedAt: string
  completedAt: string | null
  durationSeconds: number | null
  bugsFoundCount: number
}

export default function RunSummary({ queuedAt, startedAt, completedAt, durationSeconds, bugsFoundCount }: RunSummaryProps) {
  const showQueued = queuedAt && (new Date(startedAt).getTime() - new Date(queuedAt).getTime()) > 5000
  return (
    <section className="run-summary" data-testid="run-summary" aria-label="Run summary">
      {showQueued && (
        <div className="run-summary__stat" data-testid="run-summary-stat">
          <Clock size={16} aria-hidden="true" />
          <div>
            <span className="run-summary__label" data-testid="run-summary-label">Queued</span>
            <span className="run-summary__value" data-testid="run-summary-value">{new Date(queuedAt).toLocaleString()}</span>
          </div>
        </div>
      )}
      <div className="run-summary__stat" data-testid="run-summary-stat">
        <Clock size={16} aria-hidden="true" />
        <div>
          <span className="run-summary__label" data-testid="run-summary-label">Started</span>
          <span className="run-summary__value" data-testid="run-summary-value">{new Date(startedAt).toLocaleString()}</span>
        </div>
      </div>
      {completedAt && (
        <div className="run-summary__stat" data-testid="run-summary-stat">
          <Clock size={16} aria-hidden="true" />
          <div>
            <span className="run-summary__label" data-testid="run-summary-label">Completed</span>
            <span className="run-summary__value" data-testid="run-summary-value">{new Date(completedAt).toLocaleString()}</span>
          </div>
        </div>
      )}
      {durationSeconds != null && (
        <div className="run-summary__stat" data-testid="run-summary-stat">
          <Clock size={16} aria-hidden="true" />
          <div>
            <span className="run-summary__label" data-testid="run-summary-label">Duration</span>
            <span className="run-summary__value" data-testid="run-summary-value">{Math.floor(durationSeconds / 60)}m {durationSeconds % 60}s</span>
          </div>
        </div>
      )}
      <div className="run-summary__stat" data-testid="run-summary-stat">
        <Bug size={16} aria-hidden="true" />
        <div>
          <span className="run-summary__label" data-testid="run-summary-label">Bugs Found</span>
          <span
            className="run-summary__value"
            data-testid="run-summary-value"
            title={`${bugsFoundCount} bug${bugsFoundCount !== 1 ? 's' : ''} discovered during this run`}
          >
            {bugsFoundCount}
          </span>
        </div>
      </div>
    </section>
  )
}
